import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Traits } from '../../services/ory';
import { adminRolesEndpoints } from '../../api/controllers/admin-roles';

type AuthState = {
  authStatus: boolean;
  traits: Traits | null;
  logoutUrl: string;
  userUid: string;
  authoritiesList: string[] | null;
};

const initialState: AuthState = {
  authStatus: false,
  traits: null,
  logoutUrl: '',
  userUid: '',
  authoritiesList: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthStatus: (state, action: PayloadAction<boolean>) => {
      state.authStatus = action.payload;
    },
    setTraits: (state, action: PayloadAction<Traits | null>) => {
      state.traits = action.payload;
    },
    setUserUid: (state, action: PayloadAction<string>) => {
      state.userUid = action.payload;
    },
    setLogoutUrl: (state, action: PayloadAction<string>) => {
      state.logoutUrl = action.payload;
    },
    logout: (state) => {
      return state;
    },
  },
  extraReducers: (build) => {
    build.addMatcher(
      adminRolesEndpoints.endpoints.getMyAuthorities.matchFulfilled,
      (state, action) => {
        state.authoritiesList = action.payload.authorities;
      }
    );
  },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
